import { createContext, useContext } from "react";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";

import {
    UserSegmentationStatusContext,
    useSearchParameters,
    useUserSegmentationStatus
} from ".";
type ConfirmationPageContext = {
    availableProducts?: AvailableProductsResponse;
    userSegmentationContext: UserSegmentationStatusContext;
};

const ConfirmationPageContext = createContext<ConfirmationPageContext>({
    availableProducts: undefined,
    userSegmentationContext: {
        closeUserSegmentationUI: () =>
            console.warn("closeUserSegmentationUI is not defined")
    } as UserSegmentationStatusContext
});

export const useConfirmationPage = (): ConfirmationPageContext => {
    const context = useContext(ConfirmationPageContext);

    if (context === undefined) {
        throw new Error(
            "`useConfirmationPage` must be used within a `ConfirmationPageContext.Provider`"
        );
    }
    return context;
};

export const ConfirmationPageProvider = ({
    availableProducts,
    children
}: ConfirmationPageProviderProps) => {
    const { products } = useSearchParameters();
    const userSegmentationContext = useUserSegmentationStatus(products);

    return (
        <ConfirmationPageContext.Provider
            value={{ userSegmentationContext, availableProducts }}
        >
            {children}
        </ConfirmationPageContext.Provider>
    );
};

export type ConfirmationPageProviderProps = {
    availableProducts?: AvailableProductsResponse;
} & React.PropsWithChildren;
